import { render, staticRenderFns } from "./outcomeForm.vue?vue&type=template&id=f3934dea&scoped=true"
import script from "./outcomeForm.vue?vue&type=script&lang=js"
export * from "./outcomeForm.vue?vue&type=script&lang=js"
import style0 from "./outcomeForm.vue?vue&type=style&index=0&id=f3934dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3934dea",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QColor from 'quasar/src/components/color/QColor.js';
import QEditor from 'quasar/src/components/editor/QEditor.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardActions,QSpace,QBtn,QCardSection,QTabs,QTab,QIcon,QTabPanels,QTabPanel,QImg,QForm,QInput,QSelect,QCheckbox,QPopupProxy,QColor,QEditor,QItem,QItemSection,QTd,QTooltip});qInstall(component, 'directives', {ClosePopup});
